module.exports = __webpack_public_path__ + "img/Frame4388.f70381ba.png";